import PubSub from "underpub-js";
import gsap from 'gsap';

var ModalForm = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ModalForm',
	};

	$.extend(true, this.options, options);

};

ModalForm.prototype.init = function() {

	var self = this;

	this.$closeXSpans = self.options.$el.find(`.${self.options.baseClass}__closeX span`);
	this.$firstCloseXSpan = self.options.$el.find(`.${self.options.baseClass}__closeX span:first-child`);
	this.$secondCloseXSpan = self.options.$el.find(`.${self.options.baseClass}__closeX span:last-child`);

	// overlay scroll bars
	this.options.$el.overlayScrollbars({
		className: null
	});

	$('[href="#open-form-modal"]').on('click', function() {

		self.open();

	});

	this.options.$el.find(`.${self.options.baseClass}__closeX`).on('click', function() {

		self.close();

	});

	$(document).keyup(function(e) {
		if (e.keyCode === 27) self.close();
	});

	var $form = this.options.$el.find("form");

	// jQuery
	$form.on('onAfterFormieSubmit', function(e) {

		// if(typeof gtag !== "undefined"){
		// 	gtag('event', 'generate_lead', {
    //             'event_category' : 'engagement'
    //         });
		// }
		//
		// if(typeof fbq !== "undefined"){
		// 	fbq('track', 'Lead');
		// }

	});

	PubSub.subscribe("resized", function(){

		// on resize make sure the modal is positioned properly
		if (self.modalOpen) {

			var left = "calc(100% - 800px)";
			if (Breakpoint.value == "xsmall" || Breakpoint.value == "small") {
				left = 0;
			}
			else if (Breakpoint.value == "medium") {
				left = "calc(100% - 480px)";
			}
			else if (Breakpoint.value == "large") {
				left = "calc(100% - 640px)";
			}

			gsap.set(self.options.$el,
				{
					left: left
				}
			)

		}

	});

};

ModalForm.prototype.open = function() {

	var self = this;

	var left = "calc(100% - 800px)";
	if (Breakpoint.value == "xsmall" || Breakpoint.value == "small") {
		left = 0;
	}
	else if (Breakpoint.value == "medium") {
		left = "calc(100% - 480px)";
	}
	else if (Breakpoint.value == "large") {
		left = "calc(100% - 640px)";
	}

	gsap.timeline(
		{
			defaults: {
				ease: "power1.out",
			}
		}
	)
	.set(self.options.$el,
		{
			zIndex: 1002,
			visibility: "visible",
		}
	)
	.to(self.options.$el,
		{
			duration: 0.6,
			left: left
		}
	)
	// close x
	.fromTo(self.$closeXSpans,
		{
			width: 0,
		},
		{
			duration: 0.25,
			ease: "power3.out",
			width: 28
		}
	)
	.fromTo(self.$firstCloseXSpan,
		{
			rotate: 0
		},
		{
			duration: 0.25,
			rotate: 45,
			ease: "power1.inOut"
		},
		">-0.1"
	)
	.fromTo(self.$secondCloseXSpan,
		{
			rotate: 0
		},
		{
			duration: 0.25,
			rotate: -45,
			ease: "power1.inOut"
		},
		"<"
	);

};

ModalForm.prototype.close = function() {

	var self = this;

	gsap.timeline(
		{
			defaults: {
				ease: "power1.out",
			}
		}
	)
	.to(self.$closeXSpans,
		{
			duration: 0.25,
			rotate: 0,
			ease: "power1.inOut"
		}
	)
	.to(self.$closeXSpans,
		{
			duration: 0.25,
			width: 0,
			ease: "power3.in"
		},
		">-0.1"
	)
	.to(self.options.$el,
		{
			duration: 0.6,
			left: "100%"
		},
		">+0.05"
	)
	.set(self.options.$el,
		{
			zIndex: -1,
			visibility: "hidden",
		}
	);

};

export default ModalForm;
